import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddCategory from "../../../components/SuperAdmin/Category/AddCategory";

export default withRouter(connect()(AddCategory));
